<template>
	<div style="background: #fff; height: 123px;">
		<div class="advert_warp" style=" border: 0px solid #424242;">
			<div v-for="(item,index) in res" @click="toadvlink(item.advlink)" style=" float: left;
    width: calc((100% - 40px)/4);
    margin-right: 10px;
    height: 123px;
    overflow: hidden;">
				<img v-lazy="item.picture" alt="" style=" width: 100%;
    height: 100%;">
			</div>

		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				res: ''
			}
		},
		mounted() {
			this.toguangao()
		},
		methods: {
			toadvlink(id) {
				console.log(id)
				window.open(id)
			},
			async toguangao() {
				let res = await http.post('api/Common/index', {
					model: 'gg',
					type: 'content',
					mid: '1',
					fid: '13'
				})
				this.res = res.data.data.list.data.slice(0, 4)
			}
		}
	}
</script>

<style>
	.advert_warp::after {
		content: '';
		display: block;
		clear: both;
	}

	.advert_warp {
		border: 0px solid #424242;
	}

	.advert_warp>div {
		float: left;
		width: calc((100% - 40px)/4);
		margin-right: 10px;
		height: 123px;
		overflow: hidden;
	}

	.advert_warp>div>img {
		width: 100%;
		height: 100%;
	}
</style>
